import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import styleConstants from "../../../../styleConstants";
import "./source.scss";

const useStyles = makeStyles(theme => ({
  text: {
    fontSize: "1rem",
    textTransform: "uppercase",
    fontWeight: styleConstants.fontWeights.bold,
    transition: "opacity 0.3s ease-in-out",
    opacity: 0.8,
    "&:hover": {
      cursor: "pointer"
    }
  }
}));

const Indicator = props => {
  const classes = useStyles();

  return (
    <g
      className={classnames(
        classes.text,
        props.groups,
        props.current === undefined
          ? undefined
          : props.groups.includes(props.current)
          ? "active"
          : "faded"
      )}>
      <text
        id={props.id}
        onMouseEnter={props.updateCurrent}
        onMouseLeave={props.removeCurrent}
        transform={`translate(${props.tx} ${props.ty})`}>
        {props.content}
      </text>
      <g dangerouslySetInnerHTML={{ __html: props.arrows }}></g>
    </g>
  );
};

Indicator.propTypes = {
  id: PropTypes.string.isRequired,
  tx: PropTypes.number,
  ty: PropTypes.number,
  content: PropTypes.string.isRequired
};

export default Indicator;
